// Route-level feature-flag gate (issue #11 follow-up): a flagged page that is
// navigated to directly without the flag renders a 404 — the page does not
// exist for that user, matching the server's 404 on the underlying api routes.
// Hiding the nav entry alone is cosmetic; this is the actual client gate.
import type { ReactNode } from 'react';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import type { FeatureFlagKey } from '@/featureFlags';

export function NotFoundView() {
  return (
    <div className="p-10 text-center">
      <div className="text-3xl font-bold text-[var(--fg-primary)] mb-2">404</div>
      <p className="text-sm text-[var(--fg-muted)]">This page does not exist.</p>
    </div>
  );
}

export function FlagRoute({ flag, children }: { flag: FeatureFlagKey; children: ReactNode }) {
  const on = useFeatureFlag(flag);
  return on ? <>{children}</> : <NotFoundView />;
}
